import { useState, useCallback, Suspense } from 'react';

/**
 * LazyMountSection - Only mounts children when user clicks "Show"
 * Prevents API calls and component rendering until user interaction
 */
const LazyMountSection = ({ title, children }) => {
    const [show, setShow] = useState(false);
    const [mounted, setMounted] = useState(false);

    const toggleShow = useCallback(() => {
        if (!mounted) {
            setMounted(true); // Mount the component on first show
        }
        setShow(prev => !prev);
    }, [mounted]);

    return (
        <div className='bg-white shadow-md rounded-lg p-5 mt-3'>
            <div className='flex items-center gap-2'>
                <h2 className="text-2xl text-primary font-bold cursor-pointer" onClick={toggleShow}>
                    {title}
                </h2>
                <p className='text-base text-black font-bold cursor-pointer' onClick={toggleShow}>
                    {show ? "Hide" : "Show"}
                </p>
            </div>

            {mounted && show && (
                <div className="w-full mt-3">
                    <Suspense fallback={<div className="p-4 text-center">Loading section...</div>}>
                        {children}
                    </Suspense>
                </div>
            )}
        </div>
    );
};

export default LazyMountSection;
